var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDollarFilled = function SvgDollarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EDEEF0",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 12.333c-11.032 0-20 8.969-20 20 0 11.032 8.968 20 20 20s20-8.968 20-20c0-11.031-8.968-20-20-20z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 32.355c0-4.517 1.677-8.646 4.473-11.828l3.054 3.054c.258.258.56.344.86.344.301 0 .602-.13.86-.344a1.22 1.22 0 0 0 0-1.72l-3.054-3.055c3.183-2.752 7.312-4.473 11.828-4.473C41.957 14.333 50 22.42 50 32.312c0 4.516-1.677 8.645-4.473 11.828l-3.054-3.054a1.22 1.22 0 0 0-1.72 0 1.22 1.22 0 0 0 0 1.72l3.054 3.054c-3.183 2.753-7.312 4.473-11.828 4.473C22.043 50.333 14 42.29 14 32.355z",
    fill: "#00FF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.967 31.203h-.335v-6.126h.335c1.383 0 2.599.904 2.976 2.261.168.617.839.987 1.468.822a1.181 1.181 0 0 0 .838-1.439c-.629-2.344-2.808-3.947-5.282-3.947h-.335v-3.29c0-.657-.545-1.15-1.174-1.15a1.16 1.16 0 0 0-1.173 1.15v3.29h-.336c-1.467 0-2.85.575-3.856 1.562A5.2 5.2 0 0 0 25.5 28.12c0 2.96 2.473 5.386 5.491 5.386h.335v6.085h-.335c-1.383 0-2.599-.904-2.976-2.18a1.205 1.205 0 0 0-1.174-.945 1.16 1.16 0 0 0-1.174 1.152c0 .123 0 .205.042.329.671 2.343 2.809 3.947 5.282 3.947h.335v3.29c0 .657.545 1.15 1.174 1.15a1.16 1.16 0 0 0 1.174-1.15v-3.29h.335c3.018 0 5.491-2.426 5.491-5.386 0-1.44-.587-2.796-1.593-3.783a5.827 5.827 0 0 0-3.94-1.521z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.95 31.203c-1.72 0-3.103-1.357-3.103-3.043 0-.822.336-1.603.88-2.138a3.148 3.148 0 0 1 2.18-.904h.336v6.085h-.294zm3.017 8.429h-.335v-6.127h.335c.838 0 1.593.33 2.18.905.587.575.88 1.316.88 2.138.042 1.685-1.341 3.084-3.06 3.084z",
    fill: "#00FF51"
  }))));
};

export default SvgDollarFilled;